import React from 'react';

import {
  Grid,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const interestForm = (props) => {
  return (
    <React.Fragment>
      <blockquote className={classes.profileFormQuote}>
        Are you sure you want to send an interest to this candidate? <br />
        You can undo this action within 30 mins. <br />
        Note: You can only send 10 interests per day!
      </blockquote>
      <br /><br />
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="message"
            config={props.inputs.message}
            changed={event => props.inputChangedHandler(event, 'message')}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default interestForm;



// WEBPACK FOOTER //
// ./src/activities/components/interestForm.js